import Breadcrumb from "elements/breadcrumb";
import React from "react";

export default function ProductTitle({ data, breadcrumb }) {
  return (
    <section>
      <div className="container">
        <div className="row">
          <div className="col align-self-center">
            <Breadcrumb data={breadcrumb} />
          </div>

          <div className="col-md-6 py-3">
            <h2 className={`text-md-center ${data ? "" : "loading-text"}`}>
              {data ? data.data.name : "Loading"}
            </h2>
          </div>

          <div className="col"></div>
        </div>
      </div>
    </section>
  );
}
